import cpflPaulistaLogo from '../assets/logos/utility_companies/cpfl_paulista.png';
import elektroLogo from '../assets/logos/utility_companies/elektro.png';
import edpSpLogo from '../assets/logos/utility_companies/edp_sp.png';
import cemigLogo from '../assets/logos/utility_companies/cemig.png';
import enelLogo from '../assets/logos/utility_companies/enel.png';
import energisaLogo from '../assets/logos/utility_companies/energisa.png';
import lightLogo from '../assets/logos/utility_companies/light.png';

import growattLogo from '../assets/logos/monitoring_system/growatt.png';
import solarmanLogo from '../assets/logos/monitoring_system/solarman.png';
import ingeteamLogo from '../assets/logos/monitoring_system/ingeteam.png';
import canadianLogo from '../assets/logos/monitoring_system/canadian.png';
import froniusLogo from '../assets/logos/monitoring_system/fronius.png';
import solisLogo from '../assets/logos/monitoring_system/solis.png';
import fimerLogo from '../assets/logos/monitoring_system/fimer.png';
import sungrowLogo from '../assets/logos/monitoring_system/sungrow.png';
import deyeLogo from '../assets/logos/monitoring_system/deye.png';
import apsystemsLogo from '../assets/logos/monitoring_system/apsystems.png';
import hoymilesLogo from '../assets/logos/monitoring_system/hoymiles.png';
import otherLogo from '../assets/logos/monitoring_system/other.png';

const UTILITY_COMPANY_LOGOS: Record<string, string> = {
  cpfl_paulista: cpflPaulistaLogo,
  elektro: elektroLogo,
  edp_sp: edpSpLogo,
  cemig: cemigLogo,
  enel_sp: enelLogo,
  energisa: energisaLogo,
  light: lightLogo,
};

const MONITORING_SYSTEM_LOGOS: Record<string, string> = {
  growatt: growattLogo,
  solarman: solarmanLogo,
  ingeteam: ingeteamLogo,
  canadian: canadianLogo,
  fronius: froniusLogo,
  solis: solisLogo,
  fimer: fimerLogo,
  sungrow: sungrowLogo,
  deye: deyeLogo,
  apsystems: apsystemsLogo,
  hoymiles: hoymilesLogo,
  other: otherLogo,
};

const getLogo = (
  name: string | undefined,
  logos: Record<string, string>,
  defaultLogo: string
): string => {
  return name && logos[name] ? logos[name] : defaultLogo;
};

export const getUtilityCompanyLogo = (name?: string) =>
  getLogo(name, UTILITY_COMPANY_LOGOS, cpflPaulistaLogo);

export const getMonitoringSystemLogo = (name?: string) =>
  getLogo(name, MONITORING_SYSTEM_LOGOS, otherLogo);
